import React from 'react';

export function PeopleMenuIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8298 7.77C17.7598 7.76 17.6898 7.76 17.6198 7.77C16.0698 7.72 14.8398 6.45 14.8398 4.89C14.8398 3.3 16.1298 2 17.7298 2C19.3198 2 20.6198 3.29 20.6198 4.89C20.6098 6.45 19.3798 7.72 17.8298 7.77Z"
        fill="currentColor"
      />
      <path
        d="M21.0904 14.7004C19.9704 15.4504 18.4004 15.7304 16.9504 15.5404C17.3304 14.7204 17.5304 13.8104 17.5404 12.8504C17.5404 11.8504 17.3204 10.9004 16.9004 10.0704C18.3804 9.8704 19.9504 10.1504 21.0804 10.9004C22.6604 11.9404 22.6604 13.6504 21.0904 14.7004Z"
        fill="currentColor"
      />
      <path
        d="M6.74094 7.77C6.81094 7.76 6.88094 7.76 6.95094 7.77C8.50094 7.72 9.73094 6.45 9.73094 4.89C9.73094 3.29 8.44094 2 6.84094 2C5.25094 2 3.96094 3.29 3.96094 4.89C3.96094 6.45 5.19094 7.72 6.74094 7.77Z"
        fill="currentColor"
      />
      <path
        d="M6.84992 12.8506C6.84992 13.8206 7.05992 14.7406 7.43992 15.5706C6.02992 15.7206 4.55992 15.4206 3.47992 14.7106C1.89992 13.6606 1.89992 11.9506 3.47992 10.9006C4.54992 10.1806 6.05992 9.89059 7.47992 10.0506C7.06992 10.8906 6.84992 11.8406 6.84992 12.8506Z"
        fill="currentColor"
      />
      <path
        d="M12.4216 15.87C12.3416 15.86 12.2516 15.86 12.1616 15.87C10.3216 15.81 8.85156 14.3 8.85156 12.44C8.86156 10.54 10.3916 9 12.3016 9C14.2016 9 15.7416 10.54 15.7416 12.44C15.7316 14.3 14.2716 15.81 12.4216 15.87Z"
        fill="currentColor"
      />
      <path
        d="M9.17156 17.9406C7.66156 18.9506 7.66156 20.6106 9.17156 21.6106C10.8916 22.7606 13.7116 22.7606 15.4316 21.6106C16.9416 20.6006 16.9416 18.9406 15.4316 17.9406C13.7216 16.7906 10.9016 16.7906 9.17156 17.9406Z"
        fill="currentColor"
      />
    </svg>
  );
}
